// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labelEditableInput_zVcQ2 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1;
  font-family: "Inter", sans-serif;

  &:hover{
    .buttonEdit__W1OE{
      opacity: 1;
    }
  }
  .buttonEdit__W1OE{
    opacity: 0;
    cursor: pointer;
    margin-left: 1rem;
  }

  p {
    margin: 0;
    color: var(--_2-color);
  }

  .row_T_IVF {
    display: flex;
    justify-content: space-between;
    height: fit-content;
  }

  button[disabled],
  input[disabled],
  select[disabled],
  option[disabled],
  textarea[disabled] {
    background-color: transparent;
  }

  button,
  input,
  select,
  option,
  textarea {
    border: none;
    outline: none;
    background-color: var(--f4-background);
    padding: 8px;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
  }

  .button_TTmCn {
    cursor: pointer;
    background-color: transparent;
    text-decoration: underline;
    font-weight: 600;
    color: var(--_18181b-color);
  }
  input,
  textarea {
    resize: none;
    width: 100%;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;

  }
  .row_T_IVF{


  }
  .inputTextareaContainer_Ubtaa{
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--black-color);
    @media (width<=768px) {
      width: 100%;
    }
    span{
      color: var(--_71-color);
      width: 100%;
    }
  }
  .newFormatInputTextarea__McDV{
    width: 100% !important;
    color: var(--black-color);
  }
  textarea {
    field-sizing: content;
    min-height: 100px;
    color: var(--black-color);
  }
  input::placeholder,
  select::placeholder,
  option::placeholder,
  input::placeholder,
  select::placeholder,
  option::placeholder,
  input::placeholder,
  select::placeholder {
    color: var(--_807d7d-color);
  }
}
.phoneContainer_BJSa9 {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  height: 30px;
}

.delete_Mw6JS {
  background-color: var(--dc3545-background);
  height: 20px;
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  cursor: pointer;
  .icon_q04hh {
    height: 13px;
    width: 13px;
  }
}

.inputPopupContainer_aNeLW{
  display: flex;
  gap: 10px;
  flex-direction:column;
  width: 100%;

   span{
    font-size: 12px;
  }

  input{
    font-size: 12px;
  }

    &:hover{
    .buttonEdit__W1OE{
      opacity: 1;
    }
  }
    .buttonEdit__W1OE{
    opacity: 0;
    cursor: pointer;
    margin-left: 1rem;
  }
}

.textPopupContainer_Mjes7{
   display: flex;
  gap: 10px;
  width: 100%;
  justify-content: start;
  align-items: center;

  span{
    font-size: 12px;
  }

  input{
    font-size: 12px;
  }

    &:hover{
    .buttonEdit__W1OE{
      opacity: 1;
    }
  }
    .buttonEdit__W1OE{
    opacity: 0;
    cursor: pointer;
    margin-left: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/Contacts/EditableInput/EditableInput.module.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,gCAAgC;;EAEhC;IACE;MACE,UAAU;IACZ;EACF;EACA;IACE,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;;;;;IAKE,6BAA6B;EAC/B;;EAEA;;;;;IAKE,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,YAAY;IACZ,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,2BAA2B;EAC7B;EACA;;IAEE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;;EAEvB;EACA;;;EAGA;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB;MACE,WAAW;IACb;IACA;MACE,uBAAuB;MACvB,WAAW;IACb;EACF;EACA;IACE,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;;;;;;;;IAQE,2BAA2B;EAC7B;AACF;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,WAAW;;GAEV;IACC,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;IAEE;IACA;MACE,UAAU;IACZ;EACF;IACE;IACA,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;GACG,aAAa;EACd,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;IAEE;IACA;MACE,UAAU;IACZ;EACF;IACE;IACA,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n.labelEditableInput {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  flex: 1;\n  font-family: \"Inter\", sans-serif;\n\n  &:hover{\n    .buttonEdit{\n      opacity: 1;\n    }\n  }\n  .buttonEdit{\n    opacity: 0;\n    cursor: pointer;\n    margin-left: 1rem;\n  }\n\n  p {\n    margin: 0;\n    color: var(--_2-color);\n  }\n\n  .row {\n    display: flex;\n    justify-content: space-between;\n    height: fit-content;\n  }\n\n  button[disabled],\n  input[disabled],\n  select[disabled],\n  option[disabled],\n  textarea[disabled] {\n    background-color: transparent;\n  }\n\n  button,\n  input,\n  select,\n  option,\n  textarea {\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n    padding: 8px;\n    box-sizing: border-box;\n    font-family: \"Inter\", sans-serif;\n  }\n\n  .button {\n    cursor: pointer;\n    background-color: transparent;\n    text-decoration: underline;\n    font-weight: 600;\n    color: var(--_18181b-color);\n  }\n  input,\n  textarea {\n    resize: none;\n    width: 100%;\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n\n  }\n  .row{\n\n\n  }\n  .inputTextareaContainer{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: var(--black-color);\n    @media (width<=768px) {\n      width: 100%;\n    }\n    span{\n      color: var(--_71-color);\n      width: 100%;\n    }\n  }\n  .newFormatInputTextarea{\n    width: 100% !important;\n    color: var(--black-color);\n  }\n  textarea {\n    field-sizing: content;\n    min-height: 100px;\n    color: var(--black-color);\n  }\n  input::placeholder,\n  select::placeholder,\n  option::placeholder,\n  input::placeholder,\n  select::placeholder,\n  option::placeholder,\n  input::placeholder,\n  select::placeholder {\n    color: var(--_807d7d-color);\n  }\n}\n.phoneContainer {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  height: 30px;\n}\n\n.delete {\n  background-color: var(--dc3545-background);\n  height: 20px;\n  min-width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  cursor: pointer;\n  .icon {\n    height: 13px;\n    width: 13px;\n  }\n}\n\n.inputPopupContainer{\n  display: flex;\n  gap: 10px;\n  flex-direction:column;\n  width: 100%;\n\n   span{\n    font-size: 12px;\n  }\n\n  input{\n    font-size: 12px;\n  }\n\n    &:hover{\n    .buttonEdit{\n      opacity: 1;\n    }\n  }\n    .buttonEdit{\n    opacity: 0;\n    cursor: pointer;\n    margin-left: 1rem;\n  }\n}\n\n.textPopupContainer{\n   display: flex;\n  gap: 10px;\n  width: 100%;\n  justify-content: start;\n  align-items: center;\n\n  span{\n    font-size: 12px;\n  }\n\n  input{\n    font-size: 12px;\n  }\n\n    &:hover{\n    .buttonEdit{\n      opacity: 1;\n    }\n  }\n    .buttonEdit{\n    opacity: 0;\n    cursor: pointer;\n    margin-left: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelEditableInput": `labelEditableInput_zVcQ2`,
	"buttonEdit": `buttonEdit__W1OE`,
	"row": `row_T_IVF`,
	"button": `button_TTmCn`,
	"inputTextareaContainer": `inputTextareaContainer_Ubtaa`,
	"newFormatInputTextarea": `newFormatInputTextarea__McDV`,
	"phoneContainer": `phoneContainer_BJSa9`,
	"delete": `delete_Mw6JS`,
	"icon": `icon_q04hh`,
	"inputPopupContainer": `inputPopupContainer_aNeLW`,
	"textPopupContainer": `textPopupContainer_Mjes7`
};
export default ___CSS_LOADER_EXPORT___;
